import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default {
  install(app) {
    app.component(FeatherIcon.name, FeatherIcon)
  },
}
